"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StateTransitionRecord = void 0;
exports.createStateTransitionRecord = createStateTransitionRecord;
const tslib_1 = require("tslib");
const zod_1 = tslib_1.__importDefault(require("zod"));
const validation_1 = require("../validation");
/**
 * Schema for recording state transitions in the stateHistory subcollection.
 * Each record represents a single state transition for an auto-layout job.
 */
exports.StateTransitionRecord = zod_1.default.object({
    fromState: zod_1.default.string(),
    toState: zod_1.default.string(),
    transitionName: zod_1.default.string(),
    timestamp: validation_1.Timestamp,
    metadata: zod_1.default
        .object({
        reason: zod_1.default.string().optional(),
        triggeredBy: zod_1.default.string().optional(),
        externalApiVersion: zod_1.default.string().optional(),
    })
        .optional(),
});
/**
 * Creates a new state transition record.
 */
function createStateTransitionRecord(params) {
    return {
        fromState: params.fromState,
        toState: params.toState,
        transitionName: params.transitionName,
        timestamp: Date.now(),
        ...(params.metadata && { metadata: params.metadata }),
    };
}
//# sourceMappingURL=stateTransitionRecord.js.map